/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Badge, Tabs, Modal, EmptyState, DataList, toast, SectionTitle, EMPLOYEES, SKATTEREGLER, PlummePayrollEmploymentScope */
// ============================================================
// PLUMME 2.0 — Lønn / Ansatte
// ============================================================
const empTabs = () => [
  { key: 'personalia', label: t('pay.personalia') },
  { key: 'arbeidsforhold', label: t('pay.employment') },
  { key: 'lonn', label: t('pay.tabSalaryTax') },
  { key: 'slipper', label: t('pay.tabPayslipsExpenses') },
];

function KV({ rows }) {
  return <div className="kv">{rows.map(([k, v, accent]) => <div key={k} className="kv-row">
    <span className="kv-key">{k}</span>
    {accent ? <span className="badge badge-warning">{v}</span> : <span className="kv-val">{v}</span>}
  </div>)}</div>;
}

function SubCard({ children }) {
  return <Card className="mt-16" style={{ background: 'var(--panel)', boxShadow: 'none' }}>{children}</Card>;
}

const getPayrollEmployees = () => (Array.isArray(window.EMPLOYEES) ? window.EMPLOYEES : []);
const employeeId = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `emp-${Date.now()}`);
const nbNumber = (value, fallback = 0) => {
  return window.PlummeMoneyInput.number(value, fallback);
};
const employeeInitials = (name) => String(name || '').trim().split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
const taxRuleOptions = () => [
  ['ordinary', t('pay.taxRuleOption.ordinary')],
  ['svalbard', t('pay.taxRuleOption.svalbard')],
  ['jan-mayen', t('pay.taxRuleOption.janMayen')],
  ['seafarer-deduction', t('pay.taxRuleOption.seafarerDeduction')],
  ['charity', t('pay.taxRuleOption.charity')],
  ['net-pay', t('pay.taxRuleOption.netPay')],
  ['net-pay-seafarer', t('pay.taxRuleOption.netPaySeafarer')],
  ['pension-source-tax', t('pay.taxRuleOption.pensionSourceTax')],
  ['nanny', t('pay.taxRuleOption.nanny')],
  ['home-work', t('pay.taxRuleOption.homeWork')],
  ['tax-free-organization', t('pay.taxRuleOption.taxFreeOrg')],
];
const employmentTypeOptions = () => [
  ['ordinary', t('pay.employmentTypeOption.ordinary')],
  ['maritime', t('pay.employmentTypeOption.maritime')],
  ['freelance', t('pay.employmentTypeOption.freelance')],
  ['pension', t('pay.employmentTypeOption.pension')],
  ['not-employed', t('pay.employmentTypeOption.notEmployed')],
  ['simplified-private', t('pay.employmentTypeOption.simplifiedPrivate')],
  ['simplified-charity', t('pay.employmentTypeOption.simplifiedCharity')],
  ['foreign-service', t('pay.employmentTypeOption.foreignService')],
  ['board-fee', t('pay.employmentTypeOption.boardFee')],
];
const employmentFormOptions = () => [
  ['permanent', t('pay.employmentFormOption.permanent')],
  ['temporary', t('pay.employmentFormOption.temporary')],
  ['temporary-substitute', t('pay.employmentFormOption.temporarySubstitute')],
  ['permanent-hired-out', t('pay.employmentFormOption.permanentHiredOut')],
  ['temporary-hired-out', t('pay.employmentFormOption.temporaryHiredOut')],
];
const workScheduleOptions = () => [
  ['none', t('pay.shift.none')],
  ['continuous-shift', t('pay.shift.continuous')],
  ['shift', t('pay.shift.shift')],
  ['rotation', t('pay.shift.rota')],
  ['offshore', t('pay.shift.offshore')],
];
const OCCUPATION_CODE_OPTIONS = [
  { name: 'Abonnementselger', code: '5223;102' },
  { name: 'Account manager', code: '3415;111' },
  { name: 'Adjunkt (grunnskole)', code: '3310;112' },
  { name: 'Adjunkt (videregående skole)', code: '2320;104' },
  { name: 'Adm. direktør (over 9 ansatte)', code: '1210;162' },
  { name: 'Daglig leder', code: '1210;112' },
  { name: 'Regnskapsfører', code: '3313;101' },
  { name: 'Revisor', code: '2411;108' },
  { name: 'Rådgiver', code: '2422;101' },
  { name: 'Konsulent (organisasjon)', code: '2421;110' },
  { name: 'Selger (engros)', code: '3322;101' },
  { name: 'Kundebehandler', code: '4222;102' },
  { name: 'Sykepleier', code: '2221;105' },
  { name: 'Lærer (grunnskole)', code: '2330;112' },
  { name: 'Tømrer', code: '7115;101' },
  { name: 'Elektriker', code: '7411;104' },
  { name: 'Kokk', code: '5120;101' },
  { name: 'Renholder', code: '9112;101' },
];
const optionLabel = (options, value) => options.find(([key]) => key === value)?.[1]
  || options.find(([, label]) => label.toLowerCase() === String(value || '').toLowerCase())?.[1]
  || value
  || '-';
const normalizeOptionValue = (options, value, fallback) => {
  const raw = String(value || '').trim();
  if (!raw) return fallback;
  const direct = options.find(([key]) => key === raw);
  if (direct) return direct[0];
  const byLabel = options.find(([, label]) => label.toLowerCase() === raw.toLowerCase());
  return byLabel?.[0] || fallback;
};
const formatEmployeeFileSize = (size) => {
  const bytes = Number(size || 0);
  if (!bytes) return '';
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
};
const formatEmployeeDate = (value) => {
  const iso = String(value || '').slice(0, 10);
  if (!iso) return '';
  const parts = iso.split('-');
  return parts.length === 3 ? `${parts[2]}.${parts[1]}.${parts[0]}` : iso;
};
const parseEmploymentPeriodStart = (period) => {
  const first = String(period || '').split(/\s*[–-]\s*/)[0]?.trim() || '';
  const match = first.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (match) return `${match[3]}-${match[2]}-${match[1]}`;
  return first.slice(0, 10);
};
const emptyEmployee = () => ({
  id: employeeId(),
  name: '',
  initials: '',
  lonnstype: 'Timelønn',
  active: true,
  personalia: {
    arbeidsgiver: 'Hovedarbeidsgiver',
    adresse: '-',
    fnr: '-',
    epost: '-',
    telefon: '-',
    bankkonto: '-',
    feriepenger: `${nbNumber(window.PAY_SETTINGS?.holidayRate, 10.2)} %`,
    skattekort: 'Ikke hentet fra Altinn',
    notat: '-',
  },
  arbeidsforhold: {
    periode: `${new Date().toISOString().slice(0, 10)} - løpende`,
    type: 'ordinary',
    form: 'permanent',
    tidsordning: 'none',
    timer: '37.5',
    stillingsprosent: '100 %',
    permisjoner: 'Ingen registrert',
  },
  _backend: { useStandardHolidayPayRate: true },
});

// ---------- Tab panels ----------
function PersonaliaPanelConnected({ emp, onEdit, onToggleActive, onEmployeeUpdated }) {
  const p = emp.personalia;
  const fileInputRef = useRef(null);
  const [documentDescription, setDocumentDescription] = useState('');
  const [busyDocumentId, setBusyDocumentId] = useState('');
  const [uploading, setUploading] = useState(false);
  const documents = Array.isArray(emp.documents) ? emp.documents : [];
  const uploadDocuments = async (files) => {
    const selectedFiles = Array.from(files || []);
    if (!selectedFiles.length) return;
    setUploading(true);
    try {
      let latestEmployee = emp;
      for (const file of selectedFiles) {
        const result = await window.PlummeBackend.uploadEmployeeDocument(emp.id, file, documentDescription);
        latestEmployee = result.employee || latestEmployee;
      }
      onEmployeeUpdated(latestEmployee);
      setDocumentDescription('');
      if (fileInputRef.current) fileInputRef.current.value = '';
      toast(selectedFiles.length === 1 ? t('pay.documentUploaded') : t('pay.documentsUploaded'), 'success');
    } catch (error) {
      toast(error?.message || t('inbox.documentUploadFailed'), 'error');
    } finally {
      setUploading(false);
    }
  };
  const openDocument = async (document) => {
    setBusyDocumentId(document.id);
    try {
      await window.PlummeBackend.openEmployeeDocument(document);
    } catch (error) {
      toast(error?.message || t('pay.cannotOpenDocument'), 'error');
    } finally {
      setBusyDocumentId('');
    }
  };
  const downloadDocument = async (document) => {
    setBusyDocumentId(document.id);
    try {
      await window.PlummeBackend.downloadEmployeeDocument(document);
    } catch (error) {
      toast(error?.message || t('pay.cannotDownloadDocument'), 'error');
    } finally {
      setBusyDocumentId('');
    }
  };
  const deleteDocument = async (document) => {
    const confirmed = window.confirm(t('pay.confirmDeleteDocument', { name: document.name }));
    if (!confirmed) return;
    setBusyDocumentId(document.id);
    try {
      const result = await window.PlummeBackend.deleteEmployeeDocument(emp.id, document.id);
      onEmployeeUpdated(result.employee);
      toast(t('pay.documentDeleted'), 'success');
    } catch (error) {
      toast(error?.message || t('inbox.docDeleteFailed'), 'error');
    } finally {
      setBusyDocumentId('');
    }
  };
  return <div>
    <Card>
      <div className="row between" style={{ marginBottom: 6 }}>
        <div><h3 className="t-h2">{t('pay.personalia')}</h3><div className="t-sm muted">{t('pay.personalInfo')}</div></div>
        <Button variant="secondary" icon="pencil" onClick={onEdit}>{t('pay.edit')}</Button>
      </div>
      <KV rows={[
        [t('pay.mainOrSecondaryEmployer'), p.arbeidsgiver === 'Biarbeidsgiver' ? t('pay.secondaryEmployerOption') : t('pay.mainEmployerOption')],
        [t('pay.address'), p.adresse],
        [t('pay.nationalId'), p.fnr],
        [t('pay.email'), p.epost],
        [t('pay.phone'), p.telefon],
        [t('pay.bankAccount'), p.bankkonto],
        [t('pay.holidayPay'), p.feriepenger],
        [t('pay.taxCardValidUntil'), p.skattekort.startsWith('Ikke') ? t('pay.notFetchedFromAltinn') : p.skattekort, p.skattekort.startsWith('Ikke')],
        [t('pay.note'), p.notat],
      ]} />
      <div className="mt-16"><Button variant={payrollEmploymentActive(emp) ? 'danger' : 'secondary'} icon={payrollEmploymentActive(emp) ? 'logout' : 'check'} onClick={onToggleActive}>{payrollEmploymentActive(emp) ? t('pay.endEmployment') : t('pay.reopenEmployment')}</Button></div>
      <SubCard>
        <div className="row between wrap gap-12" style={{ alignItems: 'flex-end' }}>
          <div><h3 className="t-h3">{t('pay.documents')}</h3><div className="t-sm muted">{documents.length ? t('pay.documentsCount', { count: documents.length }) : t('pay.noDocumentsUploaded')}</div></div>
          <div className="row wrap gap-12" style={{ alignItems: 'flex-end' }}>
            <Field label={t('pay.description')} style={{ minWidth: 220 }}>
              <Input value={documentDescription} onChange={(event) => setDocumentDescription(event.target.value)} placeholder={t('pay.contract')} />
            </Field>
            <input
              ref={fileInputRef}
              type="file"
              multiple
              accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png"
              style={{ display: 'none' }}
              onChange={(event) => uploadDocuments(event.target.files)}
            />
            <Button variant="secondary" icon="upload" disabled={uploading} onClick={() => fileInputRef.current?.click()}>{uploading ? t('pay.uploading') : t('pay.newDocument')}</Button>
          </div>
        </div>
        {documents.length ? <div className="col gap-8 mt-16">
          {documents.map((document) => {
            const meta = [document.description, formatEmployeeFileSize(document.size), formatEmployeeDate(document.uploadedAt)].filter(Boolean).join(' - ');
            return <div key={document.id} className="row between wrap gap-12" style={{ padding: '10px 0', borderTop: '1px solid var(--border)' }}>
              <button type="button" className="t-sm" style={{ background: 'none', border: 0, padding: 0, textAlign: 'left', cursor: 'pointer', fontWeight: 800, color: 'var(--ink)' }} onClick={() => openDocument(document)}>
                <span>{document.name}</span>
                {meta ? <span className="muted" style={{ display: 'block', fontWeight: 600, marginTop: 2 }}>{meta}</span> : null}
              </button>
              <div className="row-actions">
                <IconButton name="eye" size="sm" variant="ghost" disabled={busyDocumentId === document.id} onClick={() => openDocument(document)} title={t('pay.open')} />
                <IconButton name="download" size="sm" variant="ghost" disabled={busyDocumentId === document.id} onClick={() => downloadDocument(document)} title={t('pay.download')} />
                <IconButton name="trash" size="sm" variant="ghost" disabled={busyDocumentId === document.id} onClick={() => deleteDocument(document)} title={t('pay.delete')} />
              </div>
            </div>;
          })}
        </div> : null}
      </SubCard>
    </Card>
  </div>;
}

function ArbeidsforholdPanelConnected({ emp, onEdit }) {
  const a = emp.arbeidsforhold;
  return <Card>
    <div className="row between" style={{ marginBottom: 6 }}>
      <div><h3 className="t-h2" data-help={t('helpTopics.employment.body')} data-help-title={t('helpTopics.employment.title')}>{t('pay.employment')}</h3><div className="t-sm muted">{t('pay.positionAndAgreement')}</div></div>
      <Button variant="secondary" icon="pencil" onClick={onEdit}>{t('pay.edit')}</Button>
    </div>
    <KV rows={[
      [t('pay.period'), a.periode],
      [t('pay.employmentType'), optionLabel(employmentTypeOptions(), a.type)],
      [t('pay.employmentForm'), optionLabel(employmentFormOptions(), a.form)],
      [t('pay.workingHoursScheme'), optionLabel(workScheduleOptions(), a.tidsordning)],
      [t('pay.hoursInFullWeek'), a.timer],
      [t('pay.ftePercent'), a.stillingsprosent],
      [t('pay.leaveOfAbsence'), a.permisjoner === 'Ingen registrert' ? t('pay.noLeaveRegistered') : a.permisjoner],
    ]} />
  </Card>;
}

function YrkeskodeSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (!open) return undefined;
    const closeOnOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [open]);
  const list = OCCUPATION_CODE_OPTIONS.filter((option) => {
    const q = query.toLowerCase();
    return !q || option.name.toLowerCase().includes(q) || option.code.includes(query);
  });
  return <div ref={ref} style={{ position: 'relative' }}>
    <button type="button" className="input" onClick={() => setOpen((current) => !current)} style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, textAlign: 'left', cursor: 'pointer' }}>
      <span className={value ? '' : 'muted'}>{value || t('pay.selectOccupationCode')}</span>
      <Icon name="chevDown" size={16} />
    </button>
    {open && <div style={{ position: 'absolute', zIndex: 60, top: 'calc(100% + 6px)', left: 0, right: 0, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', boxShadow: 'var(--sh-lg)', padding: 8, maxHeight: 288, overflow: 'auto' }}>
      <div style={{ marginBottom: 8 }}><Input icon="search" autoFocus placeholder={t('pay.searchOccupationCodes')} value={query} onChange={(event) => setQuery(event.target.value)} /></div>
      {list.length === 0
        ? <div className="t-sm muted" style={{ padding: '12px 10px', fontWeight: 600 }}>{t('pay.noOccupationCodeMatch', { query })}</div>
        : list.map((option) => <button
          type="button"
          key={option.code}
          onClick={() => { onChange(`${option.name} (${option.code})`); setOpen(false); setQuery(''); }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, width: '100%', padding: '9px 11px', border: 0, borderRadius: 'var(--r-sm)', background: 'none', textAlign: 'left', fontWeight: 700, fontSize: 14, color: 'var(--plum-700)', cursor: 'pointer' }}
        >
          <span>{option.name}</span>
          <span className="t-num muted" style={{ fontSize: 13, flex: 'none' }}>{option.code}</span>
        </button>)}
    </div>}
  </div>;
}

function ArbeidsforholdEditorModal({ open, emp, onClose, onSave }) {
  const currentYear = Number(window.PlummeBackend?.appState?.activeYear) || new Date().getFullYear();
  const previousYear = currentYear - 1;
  const [draft, setDraft] = useState(() => emp || emptyEmployee());
  useEffect(() => {
    if (open) setDraft(emp || emptyEmployee());
  }, [open, emp?.id]);
  if (!open || !emp) return null;
  const arbeidsforhold = draft.arbeidsforhold || emptyEmployee().arbeidsforhold;
  const backend = draft._backend || {};
  const setRoot = (key, value) => setDraft((current) => ({ ...current, [key]: value }));
  const setBackend = (key, value) => setDraft((current) => ({ ...current, _backend: { ...(current._backend || {}), [key]: value } }));
  const setArbeidsforhold = (key, value) => setDraft((current) => ({ ...current, arbeidsforhold: { ...(current.arbeidsforhold || {}), [key]: value } }));
  const employmentType = normalizeOptionValue(employmentTypeOptions(), backend.employmentType || arbeidsforhold.type, 'ordinary');
  const employmentForm = normalizeOptionValue(employmentFormOptions(), backend.employmentForm || arbeidsforhold.form, 'permanent');
  const workSchedule = normalizeOptionValue(workScheduleOptions(), backend.workSchedule || arbeidsforhold.tidsordning, 'none');
  const startDate = (backend.employmentStartDate || parseEmploymentPeriodStart(arbeidsforhold.periode) || new Date().toISOString().slice(0, 10)).slice(0, 10);
  const endDate = (backend.employmentEndDate || '').slice(0, 10);
  const weeklyHours = arbeidsforhold.timer || String(backend.weeklyHours ?? 37.5);
  const positionPercent = String(arbeidsforhold.stillingsprosent || backend.positionPercent || '100').replace('%', '').trim();
  const save = () => {
    const nextStartDate = (backend.employmentStartDate || startDate || new Date().toISOString().slice(0, 10)).slice(0, 10);
    const nextEndDate = (backend.employmentEndDate || '').slice(0, 10), stillActive = nextEndDate ? nextEndDate >= new Date().toISOString().slice(0, 10) : emp.active !== false;
    const nextEmploymentType = normalizeOptionValue(employmentTypeOptions(), backend.employmentType || arbeidsforhold.type, 'ordinary');
    const nextEmploymentForm = normalizeOptionValue(employmentFormOptions(), backend.employmentForm || arbeidsforhold.form, 'permanent');
    const nextWorkSchedule = normalizeOptionValue(workScheduleOptions(), backend.workSchedule || arbeidsforhold.tidsordning, 'none');
    onSave({
      ...draft, active: stillActive,
      lonnstype: draft.lonnstype || 'Timelønn',
      arbeidsforhold: {
        ...arbeidsforhold,
        periode: `${nextStartDate} - ${nextEndDate || 'løpende'}`,
        type: nextEmploymentType,
        form: nextEmploymentForm,
        tidsordning: nextWorkSchedule,
        timer: String(nbNumber(weeklyHours, 37.5)),
        stillingsprosent: `${nbNumber(positionPercent, 100)} %`,
        permisjoner: arbeidsforhold.permisjoner || 'Ingen registrert',
      },
      _backend: {
        ...backend,
        employmentStartDate: nextStartDate,
        employmentEndDate: nextEndDate || undefined, active: stillActive,
        jobTitle: backend.jobTitle || '',
        employmentType: nextEmploymentType,
        employmentForm: nextEmploymentForm,
        workSchedule: nextWorkSchedule,
        weeklyHours: nbNumber(weeklyHours, 37.5),
        positionPercent: nbNumber(positionPercent, 100),
        otherBusinessNumber: backend.otherBusinessNumber || '',
        previousYearHolidayPay: nbNumber(backend.previousYearHolidayPay, 0),
        currentYearHolidayPay: nbNumber(backend.currentYearHolidayPay, 0),
        currentYearTaxablePay: nbNumber(backend.currentYearTaxablePay, 0),
        currentYearTaxDeduction: nbNumber(backend.currentYearTaxDeduction, 0),
        lastSalaryAdjustmentDate: backend.lastSalaryAdjustmentDate || '',
        salaryStep: backend.salaryStep || '',
      },
    });
  };
  return <Modal open={open} onClose={onClose} max={720}
    title={<React.Fragment>{t('pay.employment')} <span className="muted" style={{ fontWeight: 700, fontSize: 15 }}>{emp.name}</span></React.Fragment>}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button>
      <Button icon="check" onClick={save} data-help={t('helpTopics.employment.body')} data-help-title={t('helpTopics.employment.title')}>{t('pay.saveEmployment')}</Button>
    </React.Fragment>}>
    <div className="col gap-16" style={{ paddingBottom: 4 }}>
      <div className="grid-2 gap-14">
        <Field label={t('pay.employmentFrom')} hint={t('pay.employmentFromHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Input type="date" value={startDate} onChange={(event) => setBackend('employmentStartDate', event.target.value)} />
        </Field>
        <Field label={t('pay.endDate')} hint={t('pay.endDateHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Input type="date" value={endDate} onChange={(event) => setBackend('employmentEndDate', event.target.value)} />
        </Field>
      </div>
      <Field label={t('pay.occupationCode')} hint={t('pay.occupationCodeHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
        <YrkeskodeSelect value={backend.jobTitle || ''} onChange={(value) => setBackend('jobTitle', value)} />
      </Field>
      <div className="grid-2 gap-14">
        <Field label={t('pay.employmentType')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Select value={employmentType} onChange={(event) => { setBackend('employmentType', event.target.value); setArbeidsforhold('type', event.target.value); }}>
            {employmentTypeOptions().map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </Select>
        </Field>
        <Field label={t('pay.employmentForm')} hint="Velg om den ansatte har en midlertidig kontrakt eller er ansatt uten sluttdato." help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Select value={employmentForm} onChange={(event) => { setBackend('employmentForm', event.target.value); setArbeidsforhold('form', event.target.value); }}>
            {employmentFormOptions().map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </Select>
        </Field>
      </div>
      <Field label={t('pay.workingHoursScheme')} hint={t('pay.workingHoursSchemeHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
        <Select value={workSchedule} onChange={(event) => { setBackend('workSchedule', event.target.value); setArbeidsforhold('tidsordning', event.target.value); }}>
          {workScheduleOptions().map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </Select>
      </Field>
      <div className="grid-3 gap-14">
        <Field label={t('pay.hoursFullWeek')} hint={t('pay.hoursFullWeekHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Input inputMode="decimal" value={weeklyHours} onChange={(event) => setArbeidsforhold('timer', event.target.value)} />
        </Field>
        <Field label={t('pay.salaryType')} help={t('helpTopics.payType.body')} helpTitle={t('helpTopics.payType.title')}>
          <Select value={draft.lonnstype || 'Timelønn'} onChange={(event) => setRoot('lonnstype', event.target.value)}><option value="Timelønn">{t('pay.hourlyPay')}</option><option value="Fastlønn">{t('pay.fixedPay')}</option></Select>
        </Field>
        <Field label={t('pay.ftePercent')} hint={t('pay.ftePercentHint')} help={t('helpTopics.employment.body')} helpTitle={t('helpTopics.employment.title')}>
          <Currency suffix="%" value={positionPercent} onChange={(event) => setArbeidsforhold('stillingsprosent', event.target.value)} />
        </Field>
      </div>
      <Field label={t('pay.otherEntityNumber')}>
        <Input value={backend.otherBusinessNumber || ''} onChange={(event) => setBackend('otherBusinessNumber', event.target.value)} placeholder={t('pay.optionalEntityNumber')} />
      </Field>

      <div style={{ background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', padding: '18px 20px' }}>
        <h3 className="t-h3" style={{ fontSize: 16 }}>{t('pay.priorPayOutsidePlumme')}</h3>
        <p className="t-sm muted" style={{ fontWeight: 600, lineHeight: 1.55, margin: '6px 0 16px' }}>{t('pay.priorPayHelp')}</p>
        <div className="t-h3" style={{ fontSize: 14, marginBottom: 8 }}>{t('pay.priorYearSalaryHeading', { year: previousYear })}</div>
        <Field label={t('pay.earnedHolidayPayInYear', { year: previousYear })} hint={t('pay.holidayPayNotPaidBeforeStartHint')}><Currency value={String(backend.previousYearHolidayPay ?? '')} onChange={(event) => setBackend('previousYearHolidayPay', event.target.value)} /></Field>
        <div className="t-h3" style={{ fontSize: 14, margin: '16px 0 8px' }}>{t('pay.priorYearSalaryHeading', { year: currentYear })}</div>
        <div className="col gap-12">
          <Field label={t('pay.earnedHolidayPayInYear', { year: currentYear })}><Currency value={String(backend.currentYearHolidayPay ?? '')} onChange={(event) => setBackend('currentYearHolidayPay', event.target.value)} /></Field>
          <Field label={t('pay.earnedTaxablePayInYear', { year: currentYear })} hint={t('pay.grossPayNotInPlummeHint', { year: currentYear })}><Currency value={String(backend.currentYearTaxablePay ?? '')} onChange={(event) => setBackend('currentYearTaxablePay', event.target.value)} /></Field>
          <Field label={t('pay.withheldTaxInYear', { year: currentYear })}><Currency value={String(backend.currentYearTaxDeduction ?? '')} onChange={(event) => setBackend('currentYearTaxDeduction', event.target.value)} /></Field>
        </div>
        <div className="alert alert-warning" style={{ marginTop: 16, display: 'flex', gap: 11, alignItems: 'flex-start', background: 'var(--warning-bg)', border: '1px solid var(--warning-bd)', borderRadius: 'var(--r-md)', padding: '13px 15px' }}>
          <Icon name="alertTri" size={18} style={{ color: 'var(--warning)', flex: 'none', marginTop: 1 }} />
          <div className="t-sm" style={{ fontWeight: 700, color: 'var(--ink-2)', lineHeight: 1.5 }}><b style={{ color: 'var(--ink)' }}>{t('pay.warning')}</b> {t('pay.priorYearAmountWarning', { year: currentYear })}</div>
        </div>
      </div>

      <div>
        <h3 className="t-h3" style={{ fontSize: 15, marginBottom: 12 }}>{t('pay.forPublicStatistics')}</h3>
        <div className="grid-2 gap-14">
          <Field label={t('pay.lastAdjustmentDate')}><Input type="date" value={(backend.lastSalaryAdjustmentDate || '').slice(0, 10)} onChange={(event) => setBackend('lastSalaryAdjustmentDate', event.target.value)} /></Field>
          <Field label={t('pay.salaryGrade')}><Input value={backend.salaryStep || ''} onChange={(event) => setBackend('salaryStep', event.target.value)} placeholder={t('pay.salaryGradePh')} /></Field>
        </div>
      </div>
    </div>
  </Modal>;
}

const parsePayrollAmount = (value) => {
  return window.PlummeMoneyInput.number(value, 0);
};

const formatPayrollAmount = (value, suffix = 'kr') => {
  const amount = Number(value) || 0;
  const formatted = new Intl.NumberFormat(PlummeI18n.intlLocale(), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));
  return `${amount < 0 ? '-' : ''}${formatted} ${suffix}`;
};

const getEmployeeAgreedPay = (emp) => {
  const backend = emp?._backend || {};
  const scope = PlummePayrollEmploymentScope.fromEmployee(emp);
  if (backend.agreedPayType === 'hourly' && Number(backend.agreedHourlyRate) > 0) {
    return { mode: 'timelonn', value: Number(backend.agreedHourlyRate), scope };
  }
  if (backend.agreedPayType === 'annual' && Number(backend.agreedAnnualSalary) > 0) {
    return { mode: 'arslonn', value: Number(backend.agreedAnnualSalary), scope };
  }
  return null;
};

const payrollSalaryTypeLabel = (value) => {
  if (value === 'Fastlønn') return t('pay.fixedPay');
  if (value === 'Timelønn') return t('pay.hourlyPay');
  return value || '';
};

const employeeFixedLineLabel = (line = {}) => {
  const payType = String(line.payType || '').toLowerCase();
  if (payType === 'monthly-salary') return t('pay.fixedPay');
  if (payType.includes('overtime')) return t('pay.hourlyOvertimePay');
  if (payType.includes('hourly')) return t('pay.hourlyPay');
  if (payType.includes('holiday')) return t('pay.holidayPay');
  if (payType.includes('pension')) return t('pay.pension');
  return line.employmentLabel || line.payType || t('pay.fixedLine');
};

const employeeFixedLineForDialog = (line = {}, emp = {}) => ({
  ...line,
  employeeId: emp.id,
  emp: emp.name,
  type: employeeFixedLineLabel(line),
  note: line.comment || line.employmentLabel || '',
  _backend: { ...line, employeeId: emp.id },
});

function AvtaltLonnModal({ initial, onClose, onSave }) {
  const [mode, setMode] = useState(initial?.mode === 'timelonn' ? 'timelonn' : 'arslonn');
  const [value, setValue] = useState(initial?.value == null ? '' : String(initial.value));
  const initialScope = initial?.scope || PlummePayrollEmploymentScope.fromEmployee({});
  const [employmentScope, setEmploymentScope] = useState(initialScope.employmentScope);
  const [hoursPeriod, setHoursPeriod] = useState(initialScope.hoursPeriod || 'week');
  const [weeklyHours, setWeeklyHours] = useState(String(initialScope.weeklyHours || 37.5));
  const [monthlyHours, setMonthlyHours] = useState(String(initialScope.monthlyHours || 162.5));
  const scope = PlummePayrollEmploymentScope.normalizeDraft({ employmentScope, hoursPeriod, weeklyHours, monthlyHours });
  const setFullTime = () => {
    const fullTime = PlummePayrollEmploymentScope.normalizeDraft({ employmentScope: 'full_time' });
    setEmploymentScope('full_time');
    setHoursPeriod('week');
    setWeeklyHours(String(fullTime.weeklyHours));
    setMonthlyHours(String(fullTime.monthlyHours));
  };
  const save = () => {
    const parsed = parsePayrollAmount(value);
    if (!parsed) {
      toast(t('pay.amountRequired'), 'warning');
      return;
    }
    onSave({ mode, value: parsed, scope });
  };
  const hourlyHint = mode === 'timelonn'
    ? t('pay.estimatedAnnualSalaryFrom', { summary: PlummePayrollEmploymentScope.summary(scope) })
    : undefined;
  return <Modal open onClose={onClose} title={t('pay.agreedSalary')} max={620}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button>
      <Button icon="check" onClick={save}>{t('pay.save')}</Button>
    </React.Fragment>}>
    <div className="col gap-16" style={{ paddingBottom: 4 }}>
      <div className="alert alert-warning" style={{ display: 'flex', gap: 11, alignItems: 'flex-start', background: 'var(--warning-bg)', border: '1px solid var(--warning-bd)', borderRadius: 'var(--r-md)', padding: '14px 16px' }}>
        <Icon name="info" size={18} style={{ color: 'var(--warning)', flex: 'none', marginTop: 1 }} />
        <span className="t-sm" style={{ fontWeight: 700, color: 'var(--ink-2)', lineHeight: 1.5 }}>{t('pay.agreedSalaryInternalNote')}</span>
      </div>
      <div className="grid-2 gap-14">
        <button type="button" className="input" onClick={() => setMode('arslonn')} style={{ minHeight: 56, display: 'flex', alignItems: 'center', gap: 10, borderColor: mode === 'arslonn' ? 'var(--plum-500)' : 'var(--border)', fontWeight: 800, cursor: 'pointer' }}>
          <span style={{ width: 18, height: 18, borderRadius: 'var(--r-pill)', border: '2px solid var(--plum-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>{mode === 'arslonn' ? <span style={{ width: 8, height: 8, borderRadius: 'var(--r-pill)', background: 'var(--plum-600)' }} /> : null}</span>
          <span>{t('pay.annualSalary')}</span>
        </button>
        <button type="button" className="input" onClick={() => setMode('timelonn')} style={{ minHeight: 56, display: 'flex', alignItems: 'center', gap: 10, borderColor: mode === 'timelonn' ? 'var(--plum-500)' : 'var(--border)', fontWeight: 800, cursor: 'pointer' }}>
          <span style={{ width: 18, height: 18, borderRadius: 'var(--r-pill)', border: '2px solid var(--plum-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>{mode === 'timelonn' ? <span style={{ width: 8, height: 8, borderRadius: 'var(--r-pill)', background: 'var(--plum-600)' }} /> : null}</span>
          <span>{t('pay.hourlyPay')}</span>
        </button>
      </div>
      <Field label={mode === 'arslonn' ? t('pay.annualSalary') : t('pay.hourlyPay')} hint={hourlyHint}>
        <Currency suffix={mode === 'arslonn' ? 'kr' : 'kr/time'} value={value} onChange={(event) => setValue(event.target.value)} placeholder="0" />
      </Field>
      <div className="grid-2 gap-14">
        <button type="button" className="input" onClick={setFullTime} style={{ minHeight: 56, display: 'flex', alignItems: 'center', gap: 10, borderColor: employmentScope === 'full_time' ? 'var(--plum-500)' : 'var(--border)', fontWeight: 800, cursor: 'pointer' }}>
          <span style={{ width: 18, height: 18, borderRadius: 'var(--r-pill)', border: '2px solid var(--plum-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>{employmentScope === 'full_time' ? <span style={{ width: 8, height: 8, borderRadius: 'var(--r-pill)', background: 'var(--plum-600)' }} /> : null}</span>
          <span>{t('pay.fullTime')}</span>
        </button>
        <button type="button" className="input" onClick={() => setEmploymentScope('part_time')} style={{ minHeight: 56, display: 'flex', alignItems: 'center', gap: 10, borderColor: employmentScope === 'part_time' ? 'var(--plum-500)' : 'var(--border)', fontWeight: 800, cursor: 'pointer' }}>
          <span style={{ width: 18, height: 18, borderRadius: 'var(--r-pill)', border: '2px solid var(--plum-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flex: 'none' }}>{employmentScope === 'part_time' ? <span style={{ width: 8, height: 8, borderRadius: 'var(--r-pill)', background: 'var(--plum-600)' }} /> : null}</span>
          <span>{t('pay.partTime')}</span>
        </button>
      </div>
      {employmentScope === 'part_time' && <div className="grid-2 gap-14">
        <Field label={t('pay.adjustHoursBy')}>
          <Select value={hoursPeriod} onChange={(event) => setHoursPeriod(event.target.value)}>
            <option value="week">{t('pay.perWeek')}</option>
            <option value="month">{t('pay.perMonth')}</option>
          </Select>
        </Field>
        <Field label={hoursPeriod === 'month' ? t('pay.hoursPerMonth') : t('pay.hoursPerWeek')} hint={`${scope.positionPercent.toLocaleString(PlummeI18n.intlLocale())} % stilling`}>
          <Input inputMode="decimal" value={hoursPeriod === 'month' ? monthlyHours : weeklyHours} onChange={(event) => hoursPeriod === 'month' ? setMonthlyHours(event.target.value) : setWeeklyHours(event.target.value)} />
        </Field>
      </div>}
    </div>
  </Modal>;
}

function LonnPanel({ emp, onSaveEmployee, onOpenFixedLines }) {
  const [open, setOpen] = useState(false);
  const [fixedLineDialog, setFixedLineDialog] = useState(null);
  const avtalt = getEmployeeAgreedPay(emp);
  const feriePct = parsePayrollAmount(emp?.personalia?.feriepenger || '10,2') || 10.2;
  const skattPct = Number(emp?._backend?.taxDeductionPercent) || 30;
  const agaPct = Number(emp?._backend?.employerContributionRate) || 14.1;
  const employmentScope = avtalt?.scope || PlummePayrollEmploymentScope.fromEmployee(emp);
  const annualSalary = avtalt ? PlummePayrollEmploymentScope.annualSalary(avtalt) : 0;
  const holidayPay = Math.round(annualSalary * feriePct / 100);
  const employerContribution = Math.round((annualSalary + holidayPay) * agaPct / 100);
  const estimatedTax = Math.round(annualSalary * skattPct / 100);
  const estimatedCost = annualSalary + holidayPay + employerContribution;
  const fixedLines = Array.isArray(emp?.fixedPayrollLines) ? emp.fixedPayrollLines : [];
  const fixedLineCount = fixedLines.length;
  const tileStyle = { background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', padding: '16px 18px' };
  const saveAgreedPay = (next) => {
    if (!emp) return;
    const scopePatch = PlummePayrollEmploymentScope.toBackendPatch(next.scope);
    onSaveEmployee({
      ...emp,
      arbeidsforhold: {
        ...(emp.arbeidsforhold || {}),
        timer: String(scopePatch.weeklyHours),
        stillingsprosent: `${scopePatch.positionPercent} %`,
      },
      _backend: {
        ...(emp._backend || {}),
        ...scopePatch,
        agreedPayType: next.mode === 'timelonn' ? 'hourly' : 'annual',
        agreedAnnualSalary: next.mode === 'arslonn' ? next.value : undefined,
        agreedHourlyRate: next.mode === 'timelonn' ? next.value : undefined,
      },
    });
    setOpen(false);
  };
  const deleteFixedLine = async () => {
    if (!emp?.id || !fixedLineDialog || fixedLineDialog === 'new') return;
    const confirmed = window.confirm(t('pay.confirmDeleteFixedLine', { line: employeeFixedLineLabel(fixedLineDialog), name: emp.name }));
    if (!confirmed) return;
    try {
      await window.PlummeBackend.deleteEmployeeFixedPayrollLine(emp.id, fixedLineDialog.id);
      toast(t('pay.fixedLineDeleted'), 'success');
      setFixedLineDialog(null);
    } catch (error) {
      toast(error?.message || t('pay.fixedLineDeleteFailed'), 'error');
    }
  };
  return <div className="col gap-20">
    <Card>
      <div className="row between" style={{ marginBottom: avtalt ? 16 : 12 }}>
        <div><h3 className="t-h2">{t('pay.tabSalaryTax')}</h3><div className="t-sm muted">{t('pay.agreementTaxHeading')}</div></div>
        <Button variant="secondary" icon={avtalt ? 'pencil' : 'plus'} onClick={() => setOpen(true)}>{avtalt ? t('clo.change') : t('clo.add')}</Button>
      </div>
      {avtalt ? <React.Fragment>
        <div className="grid-2 gap-14">
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{avtalt.mode === 'arslonn' ? t('pay.agreedAnnualSalary') : t('pay.agreedHourlyPay')}</div><div className="t-h2 t-num mt-4">{avtalt.mode === 'arslonn' ? formatPayrollAmount(avtalt.value) : formatPayrollAmount(avtalt.value, 'kr/time')}</div></div>
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.tax')}</div><div className="t-h2 t-num mt-4">{skattPct} %</div><div className="t-xs muted">{t('pay.notFetchedFromAltinn')}</div></div>
        </div>
        <div className="grid-2 gap-14 mt-16">
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.employmentScope')}</div><div className="t-h3">{employmentScope.employmentScope === 'part_time' ? t('pay.partTime') : t('pay.fullTime')}</div><div className="t-xs muted">{PlummePayrollEmploymentScope.summary(employmentScope)}</div></div>
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.salaryPerYear')}</div><div className="t-h3 t-num">{formatPayrollAmount(annualSalary)}</div></div>
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.holidayPay')}</div><div className="t-h3 t-num">{formatPayrollAmount(holidayPay)}</div></div>
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.employerContribution')}</div><div className="t-h3 t-num">{formatPayrollAmount(employerContribution)}</div></div>
          <div style={tileStyle}><div className="t-sm muted" style={{ fontWeight: 800 }}>{t('pay.estimatedTax')}</div><div className="t-h3 t-num">{formatPayrollAmount(estimatedTax)}</div></div>
          <div style={{ ...tileStyle, background: 'linear-gradient(180deg,var(--plum-fill-2),var(--plum-fill))', color: '#fff', gridColumn: '1 / -1', borderColor: 'var(--plum-fill)', boxShadow: 'var(--sh-primary)' }}><div className="t-sm" style={{ fontWeight: 800, color: 'rgba(255,255,255,.78)' }}>{t('pay.estimatedAnnualCost')}</div><div className="t-h2 t-num" style={{ color: '#fff' }}>{formatPayrollAmount(estimatedCost)}</div></div>
        </div>
        <p className="t-sm muted" style={{ fontWeight: 600, marginTop: 16 }}>{t('pay.internalDocumentationNote')}</p>
      </React.Fragment> : <div style={tileStyle}>
        <h3 className="t-h3">{t('pay.noAgreedSalary')}</h3>
        <p className="t-sm muted mt-4" style={{ fontWeight: 600, maxWidth: 520 }}>{t('pay.noAgreedSalaryBody')}</p>
      </div>}
    </Card>

    <Card>
      <h3 className="t-h2" style={{ marginBottom: 12 }}>{t('pay.taxCard')}</h3>
      <div className="alert alert-warning"><span className="alert-ico"><Icon name="alertTri" size={18} /></span>
        <span style={{ fontWeight: 700 }}>{t('pay.taxCardHelp')}</span></div>
    </Card>

    <Card>
      <div className="row between wrap gap-12" style={{ marginBottom: 6 }}>
        <div><h3 className="t-h2" data-help={t('helpTopics.fixedPay.body')} data-help-title={t('helpTopics.fixedPay.title')}>{t('pay.fixedLines')}</h3><div className="t-sm muted">{t('pay.fixedLinesHelp')}</div></div>
        <Badge variant="muted">{t('pay.fixedLinesRegisteredCount', { count: fixedLineCount })}</Badge>
      </div>
      <p className="t-sm muted" style={{ fontWeight: 600, margin: '8px 0 16px' }}>{fixedLineCount ? t('pay.fixedLinesOnEmployee') : t('pay.noFixedLinesRegistered')}</p>
      {fixedLines.length ? <div className="col gap-10" style={{ marginBottom: 16 }}>
        {fixedLines.map((line) => {
          const dialogLine = employeeFixedLineForDialog(line, emp);
          return <div key={line.id} className="row between wrap gap-12" style={{ padding: '13px 16px', border: '1px solid var(--border)', borderRadius: 'var(--r-md)', background: 'var(--panel)' }}>
            <div className="row gap-12" style={{ minWidth: 0 }}>
              <span className="icon-chip"><Icon name="wallet" size={18} /></span>
              <div style={{ minWidth: 0 }}>
                <b className="t-h3" style={{ fontSize: 14.5 }}>{employeeFixedLineLabel(line)}</b>
                <div className="t-sm muted">{line.comment || line.employmentLabel || t('pay.fixedLine')}</div>
              </div>
            </div>
            <div className="row gap-12" style={{ flex: '0 0 auto' }}>
              <b className="t-num">{formatPayrollAmount(line.amount || 0)}</b>
              <IconButton name="pencil" size="sm" variant="ghost" onClick={() => setFixedLineDialog(dialogLine)} title={t('pay.edit')} />
            </div>
          </div>;
        })}
      </div> : null}
      <div className="row between wrap gap-12">
        <Button icon="plus" onClick={() => setFixedLineDialog('new')}>{t('pay.newFixedLine')}</Button>
        <Button variant="secondary" onClick={onOpenFixedLines}>{t('pay.seeFixedLines')}</Button>
      </div>
    </Card>
    {open && <AvtaltLonnModal initial={avtalt || { scope: employmentScope }} onClose={() => setOpen(false)} onSave={saveAgreedPay} />}
    {fixedLineDialog && window.FixedPayrollLineDialog && <window.FixedPayrollLineDialog line={fixedLineDialog} lockedEmployeeId={emp.id} onClose={() => setFixedLineDialog(null)} onSaved={() => window.dispatchEvent(new Event('plumme-employees-changed'))} onDelete={fixedLineDialog !== 'new' ? deleteFixedLine : undefined} />}
  </div>;
}

const normalizePortalEmail = (value) => String(value || '').trim().toLowerCase();
const hasValidPortalEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizePortalEmail(value));
const formatPortalDateTime = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(PlummeI18n.intlLocale(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
const portalStatusMeta = (access) => {
  if (!access || access.status === 'not-invited') return { label: t('pay.portalAccess.notInvited'), variant: 'neutral' };
  if (access.status === 'active') return { label: t('pay.portalAccess.active'), variant: 'success' };
  if (access.status === 'revoked') return { label: t('pay.portalAccess.revoked'), variant: 'error' };
  return { label: t('rf.member.invited'), variant: 'warning' };
};

// ---------- Edit employee modal ----------
function EmployeeEditorModalV2({ open, emp, onClose, onSave }) {
  const [draft, setDraft] = useState(() => emp || emptyEmployee());
  useEffect(() => {
    if (open) setDraft(emp || emptyEmployee());
  }, [open, emp?.id]);
  if (!open) return null;
  const personalia = draft.personalia || emptyEmployee().personalia;
  const arbeidsforhold = draft.arbeidsforhold || emptyEmployee().arbeidsforhold;
  const backend = draft._backend || {};
  const standardHolidayPayRate = nbNumber(window.PAY_SETTINGS?.holidayRate, 10.2);
  const employeeHolidayPayRate = nbNumber(personalia.feriepenger, standardHolidayPayRate);
  const usesStandardHolidayPayRate = backend.useStandardHolidayPayRate === true || (
    backend.useStandardHolidayPayRate !== false && Math.abs(employeeHolidayPayRate - standardHolidayPayRate) < 0.0001
  );
  const setRoot = (key, value) => setDraft((current) => ({ ...current, [key]: value }));
  const setBackend = (key, value) => setDraft((current) => ({ ...current, _backend: { ...(current._backend || {}), [key]: value } }));
  const setPersonalia = (key, value) => setDraft((current) => ({ ...current, personalia: { ...(current.personalia || {}), [key]: value } }));
  const save = () => {
    const name = String(draft.name || '').trim();
    if (!name) {
      toast(t('svc.nameMissing'), 'warning');
      return;
    }
    const startDate = backend.employmentStartDate || new Date().toISOString().slice(0, 10);
    const endDate = backend.employmentEndDate || '';
    const address = [backend.addressLine1, backend.postalCode, backend.postalPlace].filter(Boolean).join(', ');
    onSave({
      ...draft,
      name,
      initials: employeeInitials(name),
      lonnstype: draft.lonnstype || 'Timelønn',
      personalia: {
        ...personalia,
        fnr: personalia.fnr || '-',
        epost: personalia.epost || '-',
        telefon: personalia.telefon || '-',
        adresse: address || personalia.adresse || '-',
        bankkonto: personalia.bankkonto || '-',
        feriepenger: `${nbNumber(personalia.feriepenger, 10.2)} %`,
        skattekort: personalia.skattekort || 'Ikke hentet fra Altinn',
        notat: personalia.notat || '-',
      },
      arbeidsforhold: {
        ...arbeidsforhold,
        periode: `${startDate} - ${endDate || 'løpende'}`,
        timer: String(nbNumber(arbeidsforhold.timer, 37.5)),
        stillingsprosent: `${nbNumber(arbeidsforhold.stillingsprosent, 100)} %`,
      },
      _backend: {
        ...backend,
        employmentStartDate: startDate,
        employmentEndDate: endDate || undefined,
        hasInternationalId: backend.hasInternationalId === true,
        hasForeignBankAccount: backend.hasForeignBankAccount === true,
        isMainEmployer: personalia.arbeidsgiver !== 'Biarbeidsgiver',
        holidayPayRate: usesStandardHolidayPayRate ? standardHolidayPayRate : employeeHolidayPayRate,
        useStandardHolidayPayRate: usesStandardHolidayPayRate,
        taxRule: backend.taxRule || 'ordinary',
      },
    });
  };
  return <Modal open={open} onClose={onClose} title={emp ? t('pay.editEmployeeTitle') : t('pay.newEmployeeTitle')} max={640}
    footer={<React.Fragment>
      <Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button>
      <Button icon="check" onClick={save}>{t('pay.saveEmployee')}</Button>
    </React.Fragment>}>
    <div className="col gap-14" style={{ paddingBottom: 8 }}>
      <Field label={t('pay.nationalId')}>
        <div className="row gap-14">
          <Input value={personalia.fnr === '-' ? '' : personalia.fnr} onChange={(event) => setPersonalia('fnr', event.target.value)} style={{ flex: 1 }} />
          <label className="chk"><input type="checkbox" checked={backend.hasInternationalId === true} onChange={(event) => setBackend('hasInternationalId', event.target.checked)} />
            <span className="box">{backend.hasInternationalId === true && <Icon name="check" size={14} stroke={3} />}</span><span>{t('pay.hasInternationalId')}</span></label>
        </div>
      </Field>
      <Field label={t('pay.name')}><Input value={draft.name || ''} onChange={(event) => setRoot('name', event.target.value)} /></Field>
      <div className="grid-2 gap-14">
        <Field label={t('pay.phone')}><Input value={personalia.telefon === '-' ? '' : personalia.telefon} onChange={(event) => setPersonalia('telefon', event.target.value)} /></Field>
        <Field label={t('pay.email')}><Input value={personalia.epost === '-' ? '' : personalia.epost} onChange={(event) => setPersonalia('epost', event.target.value)} /></Field>
      </div>
      <hr className="hairline" style={{ margin: '4px 0' }} />
      <h3 className="t-h3">{t('pay.address')}</h3>
      <Field label={t('pay.country')}><Select value={backend.country || 'Norge'} onChange={(event) => setBackend('country', event.target.value)}>{['Norge', 'Sverige', 'Danmark', 'Annet'].map((country) => <option key={country}>{country}</option>)}</Select></Field>
      <Field label={t('pay.address1')}><Input value={backend.addressLine1 || ''} onChange={(event) => setBackend('addressLine1', event.target.value)} placeholder={t('pay.streetAddress')} /></Field>
      <Field label={t('pay.address2')}><Input value={backend.addressLine2 || ''} onChange={(event) => setBackend('addressLine2', event.target.value)} placeholder={t('pay.optional')} /></Field>
      <div className="grid-2 gap-14">
        <Field label={t('pay.postalCode')}><Input value={backend.postalCode || ''} onChange={(event) => setBackend('postalCode', event.target.value)} placeholder="0000" /></Field>
        <Field label={t('pay.postalPlace')}><Input value={backend.postalPlace || ''} onChange={(event) => setBackend('postalPlace', event.target.value)} placeholder={t('pay.postalPlacePh')} /></Field>
      </div>

      <hr className="hairline" style={{ margin: '4px 0' }} />
      <Field label={t('pay.accountNumber')}><Input value={personalia.bankkonto === '-' ? '' : personalia.bankkonto} onChange={(event) => setPersonalia('bankkonto', event.target.value)} placeholder="0000 00 00000" /></Field>
      <label className="chk"><input type="checkbox" checked={backend.hasForeignBankAccount === true} onChange={(event) => setBackend('hasForeignBankAccount', event.target.checked)} />
        <span className="box">{backend.hasForeignBankAccount === true && <Icon name="check" size={14} stroke={3} />}</span><span>{t('pay.hasForeignAccount')}</span></label>
      <Field label={t('pay.holidayPay')}>
        <div className="ferie-row">
          <div className="input-affix" style={{ flex: '0 0 130px' }}><span className="affix" style={{ borderRight: '1.5px solid var(--border)' }}>%</span><input className="input" value={String(personalia.feriepenger || '').replace('%', '').trim()} disabled={usesStandardHolidayPayRate} onChange={(event) => { setBackend('useStandardHolidayPayRate', false); setPersonalia('feriepenger', event.target.value); }} /></div>
          <button type="button" className={'ferie-chip' + (!usesStandardHolidayPayRate && employeeHolidayPayRate === 10.2 ? ' on' : '')} onClick={() => { setBackend('useStandardHolidayPayRate', false); setPersonalia('feriepenger', '10.2'); }}>10,2 %</button>
          <button type="button" className={'ferie-chip' + (!usesStandardHolidayPayRate && employeeHolidayPayRate === 12 ? ' on' : '')} onClick={() => { setBackend('useStandardHolidayPayRate', false); setPersonalia('feriepenger', '12.0'); }}>12,0 %</button>
        </div>
        <label className="chk mt-8"><input type="checkbox" checked={usesStandardHolidayPayRate} onChange={(event) => {
          const on = event.target.checked;
          setBackend('useStandardHolidayPayRate', on);
          if (on) setPersonalia('feriepenger', String(standardHolidayPayRate));
        }} /><span className="box">{usesStandardHolidayPayRate && <Icon name="check" size={14} stroke={3} />}</span><span>{t('pay.useStandardHolidayRate', { rate: standardHolidayPayRate })}</span></label>
      </Field>

      <Field label={t('pay.mainOrSecondaryEmployer')} hint="Dette bestemmer hvilken del av skattekortet til den ansatte det skal beregnes skatt av.">
        <div className="col gap-8">
          <label className="row gap-10" style={{ fontWeight: 700, cursor: 'pointer' }}><input type="radio" name="biho-v2" checked={personalia.arbeidsgiver !== 'Biarbeidsgiver'} onChange={() => setPersonalia('arbeidsgiver', 'Hovedarbeidsgiver')} /> {t('pay.mainEmployerOption')}</label>
          <label className="row gap-10" style={{ fontWeight: 700, cursor: 'pointer' }}><input type="radio" name="biho-v2" checked={personalia.arbeidsgiver === 'Biarbeidsgiver'} onChange={() => setPersonalia('arbeidsgiver', 'Biarbeidsgiver')} /> {t('pay.secondaryEmployerOption')}</label>
        </div>
      </Field>
      <Field label={t('pay.taxAndDutyRules')} hint={(backend.taxRule || 'ordinary') === 'ordinary' ? undefined : t('pay.taxRuleNotSupportedHint')}>
        <Select value={backend.taxRule || 'ordinary'} onChange={(event) => setBackend('taxRule', event.target.value)}>
          {taxRuleOptions().map(([value, label]) => <option key={value} value={value}>{value === 'ordinary' ? label : `${label} – ${t('pay.taxRuleNotSupported')}`}</option>)}
        </Select>
      </Field>
      <Field label={t('pay.noteOptional')}><textarea className="input" rows={3} value={personalia.notat === '-' ? '' : personalia.notat} onChange={(event) => setPersonalia('notat', event.target.value)} placeholder={t('pay.notePh')} /></Field>
    </div>
  </Modal>;
}

// ---------- All employees list ----------
function EmployeeList({ employees, onOpen, onCreate }) {
  return <Card pad={false} className="emp-card">
    <div className="row between wrap gap-12" style={{ marginBottom: 16 }}>
      <div><h2 className="t-h1" data-help-title={t('pay.employees')} data-help={t('pay.employeesHelp')}>{t('pay.employees')}</h2><div className="t-sm muted">{t('pay.allEmployees')}</div></div>
      <Button icon="plus" onClick={onCreate} data-help-title={t('pay.newEmployee')} data-help={t('pay.newEmployeeHelp')}>{t('pay.newEmployee')}</Button>
    </div>
    {employees.length === 0 ? <EmptyState noVisual title={t('pay.noEmployees')} text={t('pay.registerFirstEmployee')} action={<Button icon="plus" onClick={onCreate}>{t('pay.newEmployee')}</Button>} /> : <DataList tableClass="emp-tbl" rows={employees} rowKey={(e) => e.id} onRowClick={(e) => onOpen(e.id)} paginate={false}
      columns={[
        { header: t('pay.employee'), sort: (e) => e.name, render: (e) => <div className="row gap-12"><span className="emp-avatar" style={{ width: 40, height: 40, fontSize: 14 }}>{e.initials}</span>
          <div style={{ minWidth: 0 }}><div className="t-h3" style={{ fontSize: 14.5 }}>{e.name}</div><div className="t-sm muted">{e.personalia.epost}</div>
          <div className="emp-lonn-inline">{t('pay.salaryTypeLabel')} <b>{payrollSalaryTypeLabel(e.lonnstype)}</b></div>
          <div className="emp-status-inline"><PayrollEmploymentBadge employee={e} /></div></div></div> },
        { header: t('pay.salaryType'), thClass: 'emp-lonn-col', cellClass: 't-sm emp-lonn-col', tdStyle: { fontWeight: 700 }, sort: (e) => e.lonnstype, render: (e) => payrollSalaryTypeLabel(e.lonnstype) },
        { header: <span data-help-title={t('pay.status')} data-help={t('pay.statusHelp')}>{t('pay.status')}</span>, thClass: 'emp-status-col', cellClass: 'emp-status-col', sort: (e) => (payrollEmploymentActive(e) ? 0 : 1), render: (e) => <PayrollEmploymentBadge employee={e} /> },
        { header: '', sortable: false, render: () => <div className="row-actions"><IconButton name="chevRight" size="sm" variant="ghost" /></div> },
      ]} />}
  </Card>;
}

function PayrollPersonnelAccessNotice({ backend }) {
  if (!backend || backend.personnelStateReadable !== false) return null;
  const membership = (backend.memberships || []).find((entry) =>
    entry.businessId === backend.activeBusinessId || entry.id === backend.activeBusinessId);
  const roleLabel = membership?.role === 'viewer' ? t('pay.readAccess') : (membership?.role || t('pay.unknownAccess'));
  return <Card className="mt-16" style={{ borderColor: 'var(--warning)', background: 'var(--warning-bg)' }}>
    <div className="row gap-12" style={{ alignItems: 'flex-start' }}>
      <span className="icon-chip" style={{ background: 'var(--card)' }}><Icon name="lock" size={18} /></span>
      <div>
        <h3 className="t-h3" style={{ margin: 0 }}>{t('pay.payrollDataHidden')}</h3>
        <p className="t-sm muted" style={{ margin: '6px 0 0', fontWeight: 700 }}>
          {t('pay.payrollDataHiddenBody', { role: roleLabel })}
        </p>
      </div>
    </div>
  </Card>;
}

// ---------- Main page ----------
function LonnPage({ subPage, setSubPage }) {
  const backend = window.PlummeBackend.useBackend();
  const [localPage, setLocalPage] = useState('employees'); // fallback when not controlled
  const page = subPage !== undefined ? subPage : localPage;
  const setPage = setSubPage || setLocalPage;
  const [mode, setMode] = useState('list'); // 'detail' | 'list' (within Ansatte)
  const [employees, setEmployees] = useState(() => getPayrollEmployees());
  const [empId, setEmpId] = useState(() => getPayrollEmployees()[0]?.id || '');
  const [tab, setTab] = useState('personalia');
  const [edit, setEdit] = useState(false);
  const [employmentEdit, setEmploymentEdit] = useState(false);
  const [creating, setCreating] = useState(false);
  const [payrollReturnRunId, setPayrollReturnRunId] = useState('');
  const [payrollOpenRunId, setPayrollOpenRunId] = useState('');
  useEffect(() => {
    const sync = () => {
      const next = getPayrollEmployees();
      setEmployees(next);
      setEmpId((current) => current && next.some((employee) => employee.id === current) ? current : next[0]?.id || '');
      if (!next.length) setMode('list');
    };
    window.addEventListener('plumme-employees-changed', sync);
    window.addEventListener('plumme-backend-state', sync);
    return () => {
      window.removeEventListener('plumme-employees-changed', sync);
      window.removeEventListener('plumme-backend-state', sync);
    };
  }, []);
  const emp = employees.find((e) => e.id === empId);
  const saveEmployee = async (employee) => {
    try {
      const savedEmployee = await window.PlummeBackend.saveEmployee({
        ...employee,
        initials: employee.initials || employeeInitials(employee.name),
      });
      applyEmployeeFromBackend(savedEmployee);
      setCreating(false);
      setEdit(false);
      setEmploymentEdit(false);
      setMode('detail');
      toast(t('r1l.employee.saved'), 'success');
    } catch (error) {
      toast(error?.message || t('pay.saveEmployeeFailed'), 'error');
    }
  };
  const applyEmployeeFromBackend = (employee) => {
    if (!employee?.id) return;
    setEmployees((current) => {
      const exists = current.some((candidate) => candidate.id === employee.id);
      return exists ? current.map((candidate) => candidate.id === employee.id ? employee : candidate) : [employee, ...current];
    });
    setEmpId(employee.id);
  };
  const toggleEmployeeActive = () => {
    if (!emp) return;
    const active = payrollEmploymentActive(emp), endDate = active ? new Date().toISOString().slice(0, 10) : '';
    saveEmployee({
      ...emp,
      active: !active,
      _backend: { ...(emp._backend || {}), active: !active, employmentEndDate: endDate || undefined },
    });
  };

  const SUB = {
    payment: PayRuns, tax: PayTax, pension: PayPension, fixed: PayFixedLines,
    travel: PayTravel, overview: PayOverview, holiday: PayHoliday, settings: PaySettings, paytypes: PayTypes,
  };
  const SubPage = SUB[page]; usePayrollPageControlAdapter({ access: backend.personnelStateReadable !== false, page, setPage, mode, employeeId: empId, pages: window.PAY_PAGES(), employees, runs: Array.isArray(window.PAY_RUNS) ? window.PAY_RUNS : [], openEmployee: (id) => { setEmpId(id); setTab('personalia'); setMode('detail'); setPage('employees'); }, openRun: (id) => { setPayrollOpenRunId(id); setPage('payment'); } });

  return <div>
    <PageHeader title={t('pay.payroll')} subtitle={t('pay.payrollSub')} help titleHelp={t('pay.payrollModuleHelp')}>
      <span data-help-title={t('pay.payrollPages')} data-help={t('pay.payrollPagesHelp')}><PayNav value={page} onChange={(p) => setPage(p)} /></span>
    </PageHeader>
    <PayrollPersonnelAccessNotice backend={backend} />

    {SubPage && <SubPage
      onOpenTravel={() => setPage('travel')}
      initialOpenRunId={page === 'payment' ? payrollOpenRunId : ''}
      onInitialOpenConsumed={() => setPayrollOpenRunId('')}
      onOpenEmployee={(employeeId, runId) => {
        setPayrollReturnRunId(runId || '');
        setEmpId(employeeId || empId);
        setTab('personalia');
        setMode('detail');
        setPage('employees');
      }}
    />}

    {page === 'employees' && (mode === 'list'
      ? <EmployeeList employees={employees} onCreate={() => setCreating(true)} onOpen={(id) => { setEmpId(id); setTab('personalia'); setMode('detail'); }} />
      : emp ? <React.Fragment>
        {/* Employee header */}
        <Card style={{ marginBottom: 18 }}>
          <div className="emp-head">
            <span className="emp-avatar">{emp.initials || employeeInitials(emp.name)}</span>
            <div className="grow" style={{ minWidth: 0 }}>
              <h2 className="t-h1">{emp.name}</h2>
              <div className="t-sm muted" style={{ fontWeight: 800 }}>{payrollSalaryTypeLabel(emp.lonnstype)}</div>
              <div className="mt-8" data-help-title={t('pay.employmentStatus')} data-help={t('pay.employmentStatusHelp')}><PayrollEmploymentBadge employee={emp} /></div>
            </div>
            {payrollReturnRunId && <Button variant="secondary" icon="arrowLeft" onClick={() => { setPayrollOpenRunId(payrollReturnRunId); setPayrollReturnRunId(''); setPage('payment'); }}>{t('pay.backToPayrollRun')}</Button>}
            <Button variant="secondary" onClick={() => setMode('list')}>{t('pay.showAllEmployees')}</Button>
          </div>
        </Card>

        {/* Tabs */}
        <div className="emp-tabwrap mt-20">
          <Tabs options={empTabs().map((entry) => ({ value: entry.key, label: entry.label }))} value={tab} onChange={setTab} />
        </div>

        <div className="mt-20">
          {tab === 'personalia' && <PersonaliaPanelConnected emp={emp} onEdit={() => setEdit(true)} onToggleActive={toggleEmployeeActive} onEmployeeUpdated={applyEmployeeFromBackend} />}
          {tab === 'arbeidsforhold' && <ArbeidsforholdPanelConnected emp={emp} onEdit={() => setEmploymentEdit(true)} />}
          {tab === 'lonn' && <LonnPanel emp={emp} onSaveEmployee={saveEmployee} onOpenFixedLines={() => setPage('fixed')} />}
          {tab === 'slipper' && <SlipperPanel emp={emp} onEmployeeUpdated={applyEmployeeFromBackend} onOpenTravel={() => setPage('travel')} />}
        </div>

        <EmployeeEditorModalV2 open={edit} emp={emp} onClose={() => setEdit(false)} onSave={saveEmployee} />
        <ArbeidsforholdEditorModal open={employmentEdit} emp={emp} onClose={() => setEmploymentEdit(false)} onSave={saveEmployee} />
      </React.Fragment> : <EmployeeList employees={employees} onCreate={() => setCreating(true)} onOpen={(id) => { setEmpId(id); setTab('personalia'); setMode('detail'); }} />)}
    <EmployeeEditorModalV2 open={creating} emp={null} onClose={() => setCreating(false)} onSave={saveEmployee} />
  </div>;
}

Object.assign(window, { LonnPage });
